<template>
  <div id="dailyChargeReport">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>业务数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>每日收费报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="changeCust"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:140px"
                            type="date"
                            :clearable="false"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:140px"
                            :clearable="false"
                            type="date"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="操作员编号::">
            <el-input placeholder="请输入操作员编号"
                      v-model="pageSearch.searchKeyWord"
                      :disabled="userNoDisabled"
                      class="search"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  ref="dt"
                  :summary-method="getSummaries"
                  show-summary
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           prop="num"
                           label="序号">
          </el-table-column>

          <el-table-column prop="fDataSrc"
                           width="100"
                           label="日期">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fCustName"
                           width="200"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fUserNo"
                           width="150"
                           label="操作员">
          </el-table-column>
          <el-table-column prop="fCalcAmt"
                           align="right"
                           label="计费金额">
          </el-table-column>
          <el-table-column prop="fDedAmt"
                           align="right"
                           label="抵扣金额">
          </el-table-column>
          <el-table-column prop="fPayAmt"
                           align="right"
                           label="实付金额">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      is_export: false,
      userNoDisabled: true,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      total: {},
      cust_list: [],
      startTime: '',
      endTime: '',
      pageSearch: {
        isNew: true,
        fCustID: '',
        fstartTime: '',
        fendTime: '',
        searchKeyWord: ''
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    page_list () {
      var starttime = this.$dateFormat(this.startTime, 'yyyy-MM-dd')
      var endtime = this.$dateFormat(this.endTime, 'yyyy-MM-dd')
      if (starttime !== endtime && (this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.loading = true
      this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd')
      this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd')
      api.dailyChargeList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.total = data.Data.total
            setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
          } else {
            // this.$message.error('提示：每日收费报表数据加载失败')
            var msg = '提示：客户收费报表数据加载失败'
            if (data && (data.Msg || '').length > 0) {
              msg = data.Msg
            }
            this.$message.error('提示：' + msg)
          }
        }
      })
    },
    changeCust (val) {
      if (val) {
        this.userNoDisabled = false
      } else {
        this.pageSearch.searchKeyWord = ''
        this.userNoDisabled = true
      }
    },
    init () {
      var today = new Date()
      var preDate = new Date(today.getTime() - 24 * 60 * 60 * 1000)
      this.startTime = new Date(preDate.getFullYear(), preDate.getMonth(), preDate.getDate(), 0, 0, 0)
      this.endTime = new Date(preDate.getFullYear(), preDate.getMonth(), preDate.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    exportData () {
      var starttime = this.$dateFormat(this.startTime, 'yyyy-MM-dd')
      var endtime = this.$dateFormat(this.endTime, 'yyyy-MM-dd')
      if (starttime !== endtime && (this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd')
      this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd')
      this.export_loading = true
      this.export_msg = '导出中……'
      var fileName = '所有客户'
      if ((this.pageSearch.fCustID || '').trim().length > 0) {
        var custArr = (this.cust_list || []).filter((item) => {
          return item.fCustID === this.pageSearch.fCustID
        })
        fileName = custArr.length > 0 ? custArr[0].unionName : ''
      }
      api.dailyChargeExport(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_每日收费报表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    getSummaries (param) {
      var sums = []
      var index = 0
      for (let key in this.total) {
        sums[index] = this.total[key]
        index++
      }
      return sums
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 180
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 66000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/report/dailyChargeReport.vue